:host(.gxg--disabled) .form-element,
:host(.gxg--disabled.form-element) {
  pointer-events: none;
  background-color: var(--gxg-background-color--disabled) !important;
  color: var(--gxg-color--disabled) !important;
  border-color: var(--gxg-border-color--disabled) !important;
  cursor: default !important;
}

:root {
  --ui-animaton-speed: 0.2s;
}

/*ALIGNMENT*/
/*Ellipsis*/
/*****************************************************
TYPOGRAPHY
*****************************************************/
/*Title 01 (Positive)*/
.gxg-title-01 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

/*Title 01 (Negative)*/
.gxg-title-01--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

/*Title 02 (Positive)*/
.gxg-title-02 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
}

.gxg-title-02--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Title 03*/
.gxg-title-03 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xs);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
}

.gxg-title-03--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xs);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  text-transform: uppercase;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Title 04*/
.gxg-title-04 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

.gxg-title-04--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
  letter-spacing: var(--letter-spacing-md);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

/*Title 05*/
.gxg-title-05 {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.556em;
}

.gxg-title-05--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-sm);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.556em;
  color: var(--color-on-primary);
}

/*Text*/
.gxg-text {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
}

.gxg-text--negative {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-on-primary);
}

.gxg-text--gray {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--gray-05);
}

/*Quote*/
.gxg-quote {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  font-style: italic;
}

.gxg-quote--negative {
  color: var(--color-on-primary);
}

/*Link*/
.gxg-link {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
}
.gxg-link:hover {
  color: var(--color-primary-hover);
}
.gxg-link:active {
  color: var(--color-primary-active);
}

.gxg-link-gray {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  color: var(--gray-04);
}
.gxg-link-gray:hover {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  color: var(--gray-04);
  color: var(--gray-06);
}

/*Alerts*/
.gxg-alert-error {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-error-dark);
  display: inline-block;
}

.gxg-alert-warning {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-warning-dark);
  display: inline-block;
}

.gxg-alert-success {
  font-family: var(--font-family-primary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-sm);
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-on-background);
  text-align: start;
  line-height: 1.455em;
  color: var(--color-success-dark);
  display: inline-block;
}

/*Tab*/
.gxg-tab--disabled {
  color: var(--color-primary-disabled);
  pointer-events: none;
}
.gxg-tab--disabled[disabled] {
  color: var(--color-primary-disabled);
  pointer-events: none;
}

/*Label*/
.gxg-label {
  font-family: var(--font-family-primary) !important;
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm) !important;
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-primary-enabled);
  text-align: center;
  line-height: 1.455em;
}
.gxg-label:hover {
  color: var(--color-primary-hover);
}
.gxg-label:focus {
  color: var(--color-primary-active);
}
.gxg-label:active {
  color: var(--color-primary-active);
}
.gxg-label[disabled] {
  color: var(--color-primary-disabled);
}

.gxg-label--negative {
  color: var(--color-on-primary);
}
.gxg-label--negative[disabled] {
  color: var(--color-on-disabled);
}

/*****************************************************
GXG-BUTTON and GXG-BUTTON-GROUP COMMON STYLES
*****************************************************/
.gxg-button-styles {
  font-family: var(--font-family-primary) !important;
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-sm) !important;
  letter-spacing: var(--letter-spacing-xs);
  color: var(--color-primary-enabled);
  text-align: center;
  line-height: 1.455em;
}

/*****************************************************
FORM ELEMENTS
*****************************************************/
.gxg-scrollbar {
  /* Track */
  /* Handle */
  /* Handle on hover */
  cursor: initial;
}
.gxg-scrollbar::-webkit-scrollbar {
  width: var(--gxg-scrollbar-width, 6px);
  height: var(--gxg-scrollbar-width, 6px);
}
.gxg-scrollbar::-webkit-scrollbar-track {
  background-color: var(--gxg-scrollbar-track-background, --gray-02);
  border-radius: var(--gxg-scrollbar-track-border-radius, 10px);
}
.gxg-scrollbar::-webkit-scrollbar-thumb {
  background-color: var(--gxg-scrollbar-track-thumb-background, --gray-05);
  border-radius: var(--gxg-scrollbar-track-thumb-radius, 10px);
  border: var(--gxg-scrollbar-track-thumb-border);
  background-clip: padding-box;
}
.gxg-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: var(--gxg-scrollbar-track-thumb-hover-background, --gray-04);
}

/*Warning*/
:host(.gxg-validation--warning) .form-element {
  border-color: var(--color-warning-dark);
}
:host(.gxg-validation--warning) .form-element:focus {
  outline-color: var(--color-warning-dark);
  border-color: var(--color-warning-dark);
}
:host(.gxg-validation--warning) .form-element:focus + .checkmark {
  --checkmark-border-color: var(--color-warning-dark);
}

/*Error*/
:host(.gxg-validation--error) .form-element {
  border-color: var(--color-error-dark);
}
:host(.gxg-validation--error) .form-element:focus {
  outline-color: var(--color-error-dark);
  border-color: var(--color-error-dark);
}
:host(.gxg-validation--error) .form-element:focus + .checkmark {
  --checkmark-border-color: var(--color-error-dark);
}

/*Success*/
:host(.gxg-validation--success) .form-element {
  border-color: var(--color-success-dark);
}
:host(.gxg-validation--success) .form-element:focus {
  outline-color: var(--color-success-dark);
  border-color: var(--color-success-dark);
}
:host(.gxg-validation--success) .form-element:focus + .checkmark {
  --checkmark-border-color: var(--color-success-dark);
}

/*Tooltip*/
.tooltip-outer-wrapper {
  display: grid;
  grid-template-columns: 0fr;
  transition: grid-template-columns var(--timing-02);
}

:host(.tooltip--visible) .tooltip-outer-wrapper {
  grid-template-columns: 1fr;
}

.tooltip-inner-wrapper {
  overflow: hidden;
  transition: 150ms width;
  width: 0;
}
.tooltip-inner-wrapper gxg-icon {
  display: flex;
  position: relative !important;
  top: 0 !important;
  transform: none !important;
  margin-inline-start: var(--spacing-comp-01);
}
.tooltip-inner-wrapper--visible {
  width: 24px;
}
.tooltip-inner-wrapper--hidden {
  display: none;
}

:host {
  display: block;
  font-size: var(--font-size-sm);
  font-family: var(--font-family-primary);
  background-color: var(--color-background);
  color: var(--color-on-background);
  height: 100%;
}
:host .container {
  height: 100%;
  border: var(--border-radius-xs) var(--border-style-regular) var(--gxg-border-color--regular);
  border-radius: var(--border-radius-sm);
  overflow: hidden;
}
:host .header {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
  background-color: var(--gray-01);
  border-bottom: var(--gxg-border-common-styles);
  padding: var(--spacing-comp-01) var(--spacing-comp-02);
  text-transform: capitalize;
  font-size: inherit;
  font-weight: var(--font-weight-semibold);
  color: var(--color-on-background);
}
:host .icon {
  margin-inline-end: var(--spacing-comp-01);
}
:host .checkbox {
  margin-inline-end: var(--spacing-comp-01);
}
:host.selected {
  background-color: var(--color-secondary-active);
  color: var(--color-always-white);
}

.main {
  overflow-y: auto;
  /* Track */
  /* Handle */
  /* Handle on hover */
  cursor: initial;
}
.main::-webkit-scrollbar {
  width: var(--gxg-scrollbar-width, 6px);
  height: var(--gxg-scrollbar-width, 6px);
}
.main::-webkit-scrollbar-track {
  background-color: var(--gxg-scrollbar-track-background, --gray-02);
  border-radius: var(--gxg-scrollbar-track-border-radius, 10px);
}
.main::-webkit-scrollbar-thumb {
  background-color: var(--gxg-scrollbar-track-thumb-background, --gray-05);
  border-radius: var(--gxg-scrollbar-track-thumb-radius, 10px);
  border: var(--gxg-scrollbar-track-thumb-border);
  background-clip: padding-box;
}
.main::-webkit-scrollbar-thumb:hover {
  background-color: var(--gxg-scrollbar-track-thumb-hover-background, --gray-04);
}
.main--no-border {
  border: none;
}

.container:focus-within {
  outline: none;
}

.container:not(:focus-within) {
  --gxg-border-color--focused: transparent;
}

:host([no-border]) .container {
  border: none;
}

/*SUGGESTION LIST*/
.suggestions__container {
  background-color: var(--gray-01);
  color: var(--gray-06);
  font-family: inherit;
  font-size: var(--font-size-sm);
  padding: var(--spacing-comp-01) var(--spacing-comp-02);
  display: flex;
  gap: var(--spacing-comp-01);
  align-items: center;
  display: none;
}
.suggestions__list {
  margin: 0;
  padding: 0;
  list-style-type: none;
  flex-grow: 1;
}
/*BORDERS*/
:host([no-border]) .container {
  border: none;
}

:host([border-top]) .container {
  border-top: 1px solid var(--gxg-border-color--regular);
}

:host([border-end]) .container {
  border-inline-end: 1px solid var(--gxg-border-color--regular);
}

:host([border-bottom]) .container {
  border-bottom: 1px solid var(--gxg-border-color--regular);
}

:host([border-start]) .container {
  border-inline-start: 1px solid var(--gxg-border-color--regular);
}

/*Disabled*/
:host(.gxg--disabled) .header {
  color: var(--gxg-color--disabled);
  border-bottom-color: var(--gxg-border-color--disabled);
}

/*********************************************
VALIDATION
**********************************************/
.messages-wrapper {
  margin-top: var(--spacing-comp-02);
  display: flex;
  gap: var(--spacing-comp-01);
  flex-direction: column;
}

:host(.large) {
  font-size: var(--font-size-lg);
}